import { User } from '../../../models/User'
import { ActionSuggestion } from '../model'
import { useAppSelector } from '../../../store/hooks'
import { selectSafeAuthenticatedUser } from '../../../store/auth/authSlice'
import { selectRoomSession } from '../../../store/meetingSummary/roomSession'
import { useMeetingUsers } from '../../../apps/professional-app/fa/MeetingSummary/hooks/users'
import { useCurrentUserIntegrations } from '../../../views/Integration/useCurrentUserIntegrations'
import { useFilterSuggestions } from './useFilterSuggestions'

export const useUpdateContactSuggestions = () => {
  const { id: currentUserId } = useAppSelector(selectSafeAuthenticatedUser)
  const roomSession = useAppSelector(selectRoomSession)

  const { usersByRoles } = useMeetingUsers(roomSession)
  const { getContactCreateOrUpdateSupportedIntegrations } = useCurrentUserIntegrations()

  const allUsers: User[] = Object.values(usersByRoles).flat()

  const suggestions = allUsers.flatMap((user): ActionSuggestion[] => {
    const userType = currentUserId === user.id ? 'current' : (user.type ?? 'anonymous')
    if (userType !== 'anonymous' && userType !== 'external') {
      return []
    }

    const contactCreateOrUpdateSupportedIntegrations = getContactCreateOrUpdateSupportedIntegrations(user)

    return contactCreateOrUpdateSupportedIntegrations.map(({ serviceId }) => ({ actionType: 'updateContact', serviceId, user }))
  })

  return useFilterSuggestions(suggestions, 'updateContact')
}
